/**
 * VoiceServiceStandalone — STUB pending M4 (standalone HTML build target).
 *
 * Full impl wraps the browser Web Speech API
 * (window.SpeechRecognition / webkitSpeechRecognition). M4 will replace
 * this stub with the real impl + a degradation banner on browsers that
 * don't expose SpeechRecognition (notably Firefox + Safari pre-14.1).
 *
 * Until M4: isAvailable returns false, startListening/stopListening
 * resolve cleanly (silently-noop pattern — UI code branches on
 * isAvailable, not on a thrown error), onTranscript returns an
 * unsubscribe stub.
 */
import {
  SttUnavailableError,
  TtsUnavailableError,
  type SpeakOptions,
  type SpeakResult,
  type SttOptions,
  type SttSession,
  type TranscriptListener,
  type UnsubscribeFn,
  type VoiceService,
} from '../types';

export class VoiceServiceStandalone implements VoiceService {
  isAvailable(): boolean {
    return false;
  }

  async startListening(): Promise<void> {
    // Silent no-op until M4 lands the real Web Speech API binding.
  }

  async stopListening(): Promise<void> {
    // Silent no-op.
  }

  onTranscript(_cb: TranscriptListener): UnsubscribeFn {
    return () => undefined;
  }

  // V1 Voice GM (2026-06-02): standalone TTS deferred to M4. The
  // browser SpeechSynthesisUtterance path is functional cross-browser
  // but doesn't match the cinematic Kokoro voice, so M4 will pair this
  // with a degradation banner. Throws — ReadAloudControl branches on
  // VoiceService.isAvailable() to hide the button entirely when false.
  async speak(_text: string, _opts?: SpeakOptions): Promise<SpeakResult> {
    throw new TtsUnavailableError('standalone TTS pending M4');
  }

  // V2 Voice GM (2026-06-02): standalone STT deferred to M4. Browser
  // SpeechRecognition is functional in Chrome/Edge but sends audio to
  // Google; standalone build can light up Web Speech later as a
  // degradation path with a banner.
  async startStt(_opts?: SttOptions): Promise<SttSession> {
    throw new SttUnavailableError('standalone STT pending M4');
  }
}
